export default __webpack_public_path__ + "static/media/motto-top.08cf98ac.png";